<template>
<div class="app">
  <AppHeader fixed>
    <SidebarToggler class="d-lg-none" display="md" mobile />
    <b-link class="navbar-brand" to="#">
      <img class="navbar-brand-full" src="static/img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
      <img class="navbar-brand-minimized" src="static/img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
    </b-link>
    <SidebarToggler class="d-md-down-none" display="lg" />
    <b-navbar-nav class="ml-auto">
      <!-- <AppHeaderDropdown right no-caret>
        <div>
          <template slot="button-content">
            <img
              src="static/img/avatars/6.jpg"
              class="img-avatar"
              alt="admin@bootstrapmaster.com" />
          </template>
          <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item>
          <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
        </div>
      </AppHeaderDropdown> -->
    <img
              src="static/img/avatars/6.jpg"
              class="img-avatar"
              alt="admin@bootstrapmaster.com" />
      <b-nav-item-dropdown  class="fa fa-cogs" right >
        <b-dropdown-item @click="Profile" class="fa fa-user"> Profile</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="logout" class="fa fa-lock"> Logout</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </AppHeader>
  <div class="app-body">
    <AppSidebar fixed>
      <SidebarHeader/>
      <SidebarForm/>
      <SidebarNav :navItems="newNav"></SidebarNav>
      <SidebarFooter/>
      <SidebarMinimizer/>
    </AppSidebar>
    <main class="main">
      <breadcrumb :list="list" />
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </main>
  </div>
</div>
</template>

<script>
import nav from "../_nav";
import { getPermission } from "@/api";
import {
  Header as AppHeader,
  HeaderDropdown as AppHeaderDropdown,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Breadcrumb
} from "@coreui/vue";
export default {
  name: "full",
  components: {
    AsideToggler,
    AppHeader,
    AppHeaderDropdown,
    AppSidebar,
    AppAside,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      newNav: [],
      itemsCount: 42
    };
  },
  created() {
    let permission = getPermission();
    let jsonPermis = JSON.parse(permission);
    jsonPermis.sort()
    var aux = [];
    var naver = JSON.parse(JSON.stringify(this.nav));
    jsonPermis.forEach(permis => {
      naver.forEach(element => {
        // console.log('permisis',permis)
        if (permis == element.map_state) {
          aux = element;
          aux.childAux = [];
          if (element.children) {
            element.children.forEach(child => {
              jsonPermis.forEach(pchild => {
                if (pchild == child.map_state) {
                  aux.childAux.push(child);
                  aux.childAux.sort()
                }
              });
            });
            aux.children = aux.childAux;
          }
          this.newNav.push(aux);
        }
      });
    });
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout");
    },
    Profile: function() {
      this.$router.push("/admin/users/profile");
    }
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/containers/DefaultContainer.vue